// © 2026 Buddy Media LLC. All rights reserved.
//
// Tiny className combiner — no clsx/tailwind-merge dependency.
// Filters falsy + joins with spaces. Sufficient for our admin UI.

export function cn(
  ...args: (string | false | null | undefined | 0)[]
): string {
  return args.filter(Boolean).join(" ");
}
